export default {
  path: '/certificados-de-temperatura',
  component: () => import('@/components/pages/TemperatureCertificates/TemperatureCertificates')
}
